import {
  ALL_TIME,
  CLAIM_ACKNOWLEDGEMENT,
  CLAIM_ESTIMATION,
  CLAIMS_LISTING,
  CLAIM_TYPE_MOBILE_ADLD,
  CLAIM_TYPE_MOBILE_EW,
  CLAIM_TYPE_MOBILE_OTSR,
  DASHBOARD_SECTION,
  PRODUCT_ID_MOBILE_ADLD,
  PRODUCT_ID_MOBILE_EW,
  PRODUCT_ID_MOBILE_OTSR,
  THIS_WEEK,
  THIS_MONTH,
  TODAY,
} from "../constants";

export const durationMapping = {
  0: TODAY,
  1: THIS_WEEK,
  2: THIS_MONTH,
  3: ALL_TIME,
};

export const productClaimType = {
  [PRODUCT_ID_MOBILE_OTSR]: CLAIM_TYPE_MOBILE_OTSR,
  [PRODUCT_ID_MOBILE_ADLD]: CLAIM_TYPE_MOBILE_ADLD,
  [PRODUCT_ID_MOBILE_EW]: CLAIM_TYPE_MOBILE_EW,
};

export const routes = {
  acknowledgement: "/loan/acknowledgement",
  dashboard: "/dashboard",
  home: "/",
  newClaim: "/claim/new",
  policies: "/claims",
  profile: "/profile",
  planfinder: "/planfinder",
};

export const sectionTitle = {
  "/": DASHBOARD_SECTION,
  "/claims": CLAIMS_LISTING,
  "/claim/new": CLAIM_ESTIMATION,
  "/dashboard": DASHBOARD_SECTION,
  "/loan/acknowledgement": CLAIM_ACKNOWLEDGEMENT,
};
